import { z } from 'zod';
export const SupportedLanguageSchema = z.enum([
    'en',
    'de',
    'hu',
    'fr'
]);

//# sourceMappingURL=language.schema.js.map